// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import styled, { css } from 'styled-components';

import { Rugby } from '../../assets/img/sports';
import { __ } from '../../i18n/l10n';
import { type ScorerType } from '../../states/scoreboards';
import theme from '../../styled-components/dark';
import { SportIdsScoreboardWithIcons, RugbyScorerTypes } from '../../types/match';

const Wrapper = styled.div`
  margin: 0.3em 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  font-size: 0.8em;
  color: ${theme.Scoreboards.scorersColor};

  display: flex;
  align-items: center;
  justify-content: flex-end;

  ${({ $invert }) =>
    $invert
      ? css`
          flex-direction: row-reverse;
        `
      : css`
          flex-direction: row;
        `}}
`;

const ScorerName = styled.div`
  flex: ${({ $displayIcon }) => ($displayIcon ? '7' : '8')};
`;

const ScorerTimer = styled.div`
  flex: ${({ $padding }) => ($padding ? '2' : '1')};
`;

const IconWrapper = styled.div`
  flex: 1;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  ${({ $invert }) =>
    $invert
      ? css`
          flex-direction: row-reverse;
        `
      : css`
          flex-direction: row;
        `}}
`;

const StyledImg = styled.img`
  width: 85%;
`;

const TextIconWrapper = styled.div`
  width: 85%;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledTextIcon = styled.div`
  text-align: center;
  background-color: ${theme.Scoreboards.scorerIconBackground};
  color: ${theme.Scoreboards.scorerIconColor};
  font-weight: bold;
  padding: 0 0.25em;
  border-radius: 3px;
`;

type ScoreboardScorerItemProps = {
  scorer: ScorerType;
  padding?: boolean;
  sportId?: number;
  invert?: boolean;
};

const ScoreboardScorerItem = ({ scorer, sportId, invert = false, padding = false }: ScoreboardScorerItemProps) => {
  const displayIcon = useMemo(() => SportIdsScoreboardWithIcons.indexOf(sportId) !== -1, [sportId]);

  const renderIcon = useCallback(() => {
    if (scorer.type) {
      switch (scorer.type) {
        case RugbyScorerTypes.PENALTY:
          return (
            <TextIconWrapper>
              <StyledTextIcon>{__('!short:ScorerPenalty')}</StyledTextIcon>
            </TextIconWrapper>
          );
        case RugbyScorerTypes.DROP:
          return (
            <TextIconWrapper>
              <StyledTextIcon>{__('!short:ScorerDrop')}</StyledTextIcon>
            </TextIconWrapper>
          );
        case RugbyScorerTypes.CONVERSION:
          return (
            <TextIconWrapper>
              <StyledTextIcon>{__('!short:ScorerConversion')}</StyledTextIcon>
            </TextIconWrapper>
          );
        default:
          return <StyledImg src={Rugby} />;
      }
    }
  }, [scorer]);

  const renderName = useCallback(() => {
    if (scorer.type === RugbyScorerTypes.PENALTY_TRY) {
      return <>{__('Penalty try')}</>;
    } else {
      return (
        <>
          {scorer.player ?? ''}
          {scorer.detail ?? ''}
        </>
      );
    }
  }, [scorer]);

  return (
    <Wrapper $invert={invert}>
      <ScorerName $displayIcon={displayIcon && sportId}>{renderName()}</ScorerName>
      <ScorerTimer $padding={padding}>{scorer.time ?? ''}</ScorerTimer>
      {displayIcon && sportId ? <IconWrapper $invert={invert}>{renderIcon()}</IconWrapper> : null}
    </Wrapper>
  );
};

export default ScoreboardScorerItem;
